import { render, staticRenderFns } from "./ImportExport.vue?vue&type=template&id=3ad0f689"
import script from "./ImportExport.vue?vue&type=script&lang=js"
export * from "./ImportExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ad0f689')) {
      api.createRecord('3ad0f689', component.options)
    } else {
      api.reload('3ad0f689', component.options)
    }
    module.hot.accept("./ImportExport.vue?vue&type=template&id=3ad0f689", function () {
      api.rerender('3ad0f689', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/ImportExport.vue"
export default component.exports